export const OrganiseEntryStatus = {
  Open: 'open',
  Completed: 'completed',
  WontDo: 'wont_do',
} as const;
export type OrganiseEntryStatus =
  (typeof OrganiseEntryStatus)[keyof typeof OrganiseEntryStatus];

export type RecurrenceFrequency = 'daily' | 'weekly' | 'monthly';

export interface OrganiseCalendar {
  id: string;
  name: string;
}

export interface OrganiseEntryCall {
  id: string;
  scheduledAt: string;
  status: string;
  category: string;
  notes?: string | null;
}

export interface OrganiseEntryAttachment {
  documentId: string;
  title: string;
  filename: string;
  contentType?: string;
  sizeBytes?: number;
}

export interface OrganiseEntryRecurrence {
  freq: RecurrenceFrequency;
  every: number;
}

export interface OrganiseEntry {
  id: string;
  calendarId: string;
  creatorAccountId: string;
  createdByName?: string | null;
  recurringEventId?: string | null;
  assigneeAccountId?: string | null;
  title: string;
  status: OrganiseEntryStatus;
  occurrenceDate?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  link?: string | null;
  note?: string | null;
  recurrence?: OrganiseEntryRecurrence | null;
  completedAt?: string | null;
  isVirtual?: boolean;
  call?: OrganiseEntryCall | null;
  attachments?: OrganiseEntryAttachment[];
}

export interface OrganiseSeries {
  id: string;
  calendarId: string;
  creatorAccountId: string;
  title: string;
  note?: string | null;
  rrule: string;
  defaultAssigneeAccountId?: string | null;
  startTime?: string | null;
  endTime?: string | null;
}

export interface CreateOrganiseEntryRequest {
  title: string;
  assigneeAccountId?: string | null;
  note?: string | null;
  startTime?: string | null;
  endTime?: string | null;
}

export interface UpdateOrganiseEntryRequest {
  title: string;
  assigneeAccountId?: string | null;
  note?: string | null;
  startTime?: string | null;
  endTime?: string | null;
}

export interface UpdateOrganiseEntryStatusRequest {
  status: OrganiseEntryStatus;
}

export interface CreateOrganiseSeriesRequest {
  title: string;
  rrule: string;
  note?: string | null;
  defaultAssigneeAccountId?: string | null;
  startTime?: string | null;
  endTime?: string | null;
}

export interface UpdateOrganiseSeriesRequest {
  title: string;
  rrule: string;
  note?: string | null;
  defaultAssigneeAccountId?: string | null;
  startTime?: string | null;
  endTime?: string | null;
}

export interface CreateOrganiseExceptionRequest {
  date: string;
}

export interface OrganiseMember {
  id: string;
  name: string;
  avatarUrl?: string;
  kindeUser?: {
    picture?: string;
  };
}

export interface OrganiseCareCircleEntries {
  careCircleId: string;
  careCircleName: string;
  calendar: OrganiseCalendar;
  entries: OrganiseEntry[];
  members: OrganiseMember[];
}
